import React from 'react'
import { Control } from 'react-redux-form'
import Icon from '@material-ui/core/Icon';
import InputAdornment from '@material-ui/core/InputAdornment';
// import TextField from '@material-ui/core/TextField';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core';

// Date stuff
import {DatePicker,MuiPickersUtilsProvider} from 'material-ui-pickers';
import DateFnsUtils from '@date-io/date-fns';

const materialTheme = createMuiTheme({
  overrides: {
    MuiPickersToolbar: {
      toolbar: {
        backgroundColor: 'transparent',
        // borderBottom: '1px solid #3A7294'
      },
    },
    MuiPickersToolbarButton: {
      toolbarBtn: {
        color: 'rgba(0,0,0,0.87)'
      },
      toolbarBtnSelected: {
        color: 'rgba(0,0,0,0.87)'
      },
    },
    MuiPickersCalendarHeader: {
      switchHeader: {
        // backgroundColor: lightBlue.A200,
      },
    },
    MuiPickersDay: {
      selected: {
        backgroundColor: 'rgba(0,0,0,0)',
        color: 'rgba(0,0,0,0.87)',
        fontWeight: 'bold',
        "&:hover": {
          backgroundColor: 'rgba(0, 0, 0, 0.08)',
          color: '#3A7294',
        }
      },
      day: {
        "&:hover": {
          color: '#3A7294',
        }
      }
    },
    MuiPickersModal: {
      dialogAction: {
        color: '#3A7294',
      },
    },
  },
});


class MyDateField extends React.Component {
  render() {
    const {FormHelperTextProps, className, children, ...props} = this.props
    const errorClass = this.props.error ? 'InputWithErrors' : 'InputFocusLabel'
    const newClassName = `${className} ${errorClass}`

    return (
      <MuiThemeProvider theme={materialTheme}>
        <DatePicker
          format="dd/MM/yyyy"
          clearable
          autoOk
          invalidDateMessage="Invalid Date"
          FormHelperTextProps={{
            classes: {
              root: 'TextInputHelperText',
              error: 'TextInput-error'
            }
          }}
          InputProps={{
            ...this.props.InputProps,
            classes: {
              error: 'TextInputContainer-error'
            },
            endAdornment: (
              <InputAdornment position="end">
                <Icon style={ this.props.value ? {} : { color: 'rgba(0,0,0,0.6)'}}>today</Icon>
              </InputAdornment>
            ),
          }}

          className={newClassName}
          {...props}
        />
      </MuiThemeProvider>
    )
  }
}

class DateInput extends React.Component {
  render() {
    const {className, ...props} = this.props

    return (
      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <Control
          component={MyDateField}
          className={className ? className : "w-100"}
          margin="normal"

          {...props}
        />
      </MuiPickersUtilsProvider>
    )
  }
}

export default DateInput



// WEBPACK FOOTER //
// ./src/js/components/inputs/DateInput.js